// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c0e39768","335":"cbf880ce","361":"6c3e9a30","453":"a22cc8a0","460":"47dd3344","552":"f8c36920","772":"f2a12e00","926":"3159e9c5","944":"17d42df7"}[chunkId] + ".chunk.js";
};